import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const SendWebPush = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M8 19H16V20C16 20.5523 15.5523 21 15 21H9C8.44772 21 8 20.5523 8 20V19Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 10.1973C21.1175 10.7078 20.0929 11 19 11C15.6863 11 13 8.31371 13 5C13 4.29873 13.1203 3.62556 13.3414 3H4C2.89543 3 2 3.89543 2 5V15C2 16.1046 2.89543 17 4 17H20C21.1046 17 22 16.1046 22 15V10.1973Z"
      fill={getColor(color, isColorInherited)}
    />
    <circle cx="19" cy="5" r="4" fill={getColor(color, isColorInherited)} />
  </SvgIcon>
);
